// extracted by mini-css-extract-plugin
export var button = "_qr-1";
export var container = "_qr-0";